import React from 'react';
import styles from './Markets.module.scss';
import Empty from './Empty/Empty';
import Outcomes from './Outcomes/Outcomes';
import { useSelector } from 'react-redux';

const Markets = ({ event }) => {
    const mainMarkets = useSelector(state => state.mainMarkets.data) || [];
    const marketColumns = useSelector(state => state.mainMarkets.columns);

    return marketColumns.map(column => {
        const hasMarket = event.markets && event.markets.length > 0;

        const foundMarket = mainMarkets.find(
            market => market.isSelected && market.selectedIndex === column
        );

        const boxes = Number(foundMarket?.outcomes?.length + foundMarket?.specifiers?.length) || 0;

        return (
            <td
                key={column}
                className={styles.marketColumn}
                style={{
                    width: boxes > 3 ? '300px' : '225px',
                    minWidth: boxes > 3 ? '300px' : '225px',
                }}
                onClick={e => e.stopPropagation()}
            >
                <table className={styles.outcomesTable}>
                    <tbody>
                        {hasMarket ? (
                            <Outcomes column={column} event={event} />
                        ) : (
                            <Empty column={column} />
                        )}
                    </tbody>
                </table>
            </td>
        );
    });
};

export default Markets;
